import * as types from './types'
import http from '@/Plugins/api'

export default {
  resetData({ commit }, data) {
    commit(types.RESET_ANALYSIS_DATA, data)
  },
  setAnalysisData({ commit }, data) {
    commit(types.SET_ANALYSIS_DATA, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  async getActivityProgress({ commit }, data) {
    const r = await http.get(`v2/reporting/activityProgress`, {
      params: data,
    })
    commit(types.SET_ACTIVITY_PROGRESS, r.data.data)
    return r.data.data
  },
  async getBodyFatProgress({ commit }, data) {
    const r = await http.get(`v2/reporting/bodyfatProgress`, {
      params: data,
    })
    commit(types.SET_BODYFAT_PROGRESS, r.data.data)
    return r.data.data
  },
  async getBodyWeightProgress({ commit }, data) {
    const r = await http.get(`v2/reporting/bodyweightProgress`, {
      params: data,
    })
    commit(types.SET_BODYWEIGHT_PROGRESS, r.data.data)
    return r.data.data
  },
  async getChallengeProgress({ commit }, data) {
    const r = await http.get(`v2/reporting/challengeProgress`, {
      params: data,
    })
    commit(types.SET_CHALLENGE_PROGRESS, r.data.data)
    return r.data.data
  },
  async getMembershipProgress({ commit }, data) {
    const r = await http.get(`v2/reporting/membershipProgress`, {
      params: data,
    })
    commit(types.SET_MEMBERSHIP_PROGRESS, r.data.data)
    return r.data.data
  },
  async getNutritionProgress({ commit }, data) {
    const r = await http.get(`v2/reporting/nutritionProgress`, {
      params: data,
    })
    commit(types.SET_NUTRITION_PROGRESS, r.data.data)
    return r.data.data
  },
  async getDashboardProgress({ commit }, data) {
    const r = await http.get(`v2/reporting/dashboardProgress`, {
      params: data,
    })
    commit(types.SET_DASHBOARD_PROGRESS, r.data.data)
    return r.data.data
  },
}
